import React from 'react';
import PropTypes from 'prop-types';
import Fade from '@mui/material/Fade';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classnames from 'classnames';

const styles = () => ({
  root: {
    pointerEvents: 'inherit',
  },
});

const HoverMenu = ({
  classes,
  className,
  children,
  isVisible,
  PaperProps,
}) => {
  if (!children) {
    return null;
  }

  return (
    <Fade in={isVisible}>
      <div
        className={classnames(classes.root, className, 'hoverMenuContainer')}
        {...PaperProps}
      >
        {children}
      </div>
    </Fade>
  );
};

HoverMenu.defaultProps = {
  className: '',
  PaperProps: {},
};

HoverMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
  PaperProps: PropTypes.object,
};

export default withStyles(styles)(HoverMenu);
